import { useTranslation } from 'react-i18next'
import { useState } from 'react'

import { Button, Flex, Typography } from '@percent/lemonade'
import { ScimProps } from './Scim.types'
import { usePermissionCheck } from '@percent/partner-dashboard/common/hooks/useAllow/usePermissionCheck'
import styles from './Scim.module.scss'
import { ScimApiKeysListTable } from './scimApiKeysTable/ScimApiKeysTable'
import { CreateScimApiKeyModal } from './scimApiKeysTable/modals/CreateScimApiKeyModal'

export function Scim({ refresh, isLoading, keysData, nextPage, previousPage }: ScimProps) {
  const { t } = useTranslation()
  const { userCan } = usePermissionCheck()
  const canManageApiKeys = userCan('manageApiKeys')

  const [isOpenCreateScimApiKeyModal, setIsOpenCreateScimApiKeyModal] = useState(false)

  const handleRefreshScimAPIKeys = (shouldRefresh: boolean) => {
    if (shouldRefresh) {
      refresh()
    }
  }

  return (
    <>
      <Flex direction="column" p={16}>
        <Flex w="100%" justify="space-between">
          <Typography variant="h3" className={styles.scimHeaderTitle}>
            {t('table.scim.title')}
          </Typography>
          {canManageApiKeys && (
            <Button
              size="small"
              onClick={() => setIsOpenCreateScimApiKeyModal(true)}
              data-testid="create-scim-credentials-btn"
            >
              {t('button.createScimCredentials')}
            </Button>
          )}
        </Flex>
        <Flex mt="16px">
          <Typography variant="large" className={styles.justify}>
            {t('table.scim.description')}
          </Typography>
        </Flex>
      </Flex>
      <ScimApiKeysListTable
        data={keysData}
        isLoading={isLoading || !keysData}
        refresh={() => handleRefreshScimAPIKeys(true)}
        nextPage={nextPage}
        previousPage={previousPage}
        canManageApiKeys={canManageApiKeys}
      />
      <CreateScimApiKeyModal
        open={isOpenCreateScimApiKeyModal}
        onClose={() => {
          setIsOpenCreateScimApiKeyModal(false)
        }}
        refresh={() => handleRefreshScimAPIKeys(true)}
      />
    </>
  )
}
